import { Form, Radio, Typography } from "antd";
import { useEffect } from "react";
import styled from "styled-components";
import { FluxoResposta } from "../cadastroCotaUsuario.types";
import { OnboardingFrame, SubmitButton } from "../utils";

interface Props {
  fluxo: FluxoResposta;
  submitting: boolean;
  onConcluir: (payload: Record<string, unknown>) => Promise<void>;
}

const Opcoes = styled(Radio.Group)`
  display: grid;
  gap: 14px;
  width: 100%;
  .ant-radio-wrapper {
    align-items: flex-start;
    border: 1px solid #d7e2e6;
    border-radius: 14px;
    margin: 0;
    padding: 18px 20px;
  }
  .ant-radio-wrapper-checked { background: #eef8f8; border-color: #0b6673; }
  .ant-radio { margin-top: 3px; }
`;

export function EtapaSituacaoCota({ fluxo, submitting, onConcluir }: Props) {
  const [form] = Form.useForm();
  const salvo = (fluxo.dadosPreenchidos?.venda ?? fluxo.dadosPreenchidos?.situacaoCota) as
    | { situacao?: "QUITADO" | "NAO_QUITADO"; escriturada?: boolean }
    | undefined;

  useEffect(() => { form.setFieldsValue(salvo); }, [form, salvo?.situacao, salvo?.escriturada]);

  return (
    <OnboardingFrame fluxo={fluxo} title="Sua cota está totalmente quitada?">
      <Form layout="vertical" form={form} initialValues={salvo} onFinish={onConcluir}>
        <Form.Item name="situacao" rules={[{ required: true, message: "Escolha uma opção para continuar." }]}>
          <Opcoes>
            <Radio value="QUITADO">
              <Typography.Text strong>Sim, está quitada</Typography.Text>
              <Typography.Paragraph type="secondary" style={{ margin: "5px 0 0" }}>
                Não há saldo devedor referente à aquisição da cota.
              </Typography.Paragraph>
            </Radio>
            <Radio value="NAO_QUITADO">
              <Typography.Text strong>Não, ainda possui saldo devedor</Typography.Text>
              <Typography.Paragraph type="secondary" style={{ margin: "5px 0 0" }}>
                Ainda existem valores a pagar pela aquisição da cota.
              </Typography.Paragraph>
            </Radio>
          </Opcoes>
        </Form.Item>

        <Form.Item noStyle shouldUpdate={(prev, next) => prev.situacao !== next.situacao}>
          {({ getFieldValue }) => getFieldValue("situacao") === "QUITADO" ? (
            <Form.Item
              label="Sua cota já está escriturada?"
              name="escriturada"
              rules={[{ required: true, message: "Informe se a cota está escriturada." }]}
            >
              <Radio.Group>
                <Radio value>Sim</Radio>
                <Radio value={false}>Não</Radio>
              </Radio.Group>
            </Form.Item>
          ) : null}
        </Form.Item>
        <SubmitButton label="Continuar" loading={submitting} />
      </Form>
    </OnboardingFrame>
  );
}
